import { sampleNews, utils } from './modules.js';

export class NewsManager {
    constructor() {
        this.newsData = [...sampleNews];
        this.currentFilter = 'todos';
        this.newsIdCounter = this.newsData.length + 1;
        this.newsGrid = document.getElementById('newsGrid');
        this.filterButtons = document.querySelectorAll('.filter-btn');
        this.addNewsBtn = document.querySelector('.add-news-btn');
        this.newsModal = document.getElementById('newsModal');
        this.newsForm = document.getElementById('newsForm');
        this.closeBtn = document.querySelector('.close');
    }

    init() {
        this.renderNews();
        this.setupEventListeners();
        utils.setTodayDate();
    }

    setupEventListeners() {
        // Filter buttons
        this.filterButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                this.filterButtons.forEach(b => b.classList.remove('active'));
                e.target.classList.add('active');
                this.currentFilter = e.target.dataset.filter;
                this.renderNews();
            });
        });

        // Add news button
        this.addNewsBtn.addEventListener('click', () => this.openNewsModal());

        // Modal controls
        this.closeBtn.addEventListener('click', () => this.closeNewsModal());
        window.addEventListener('click', (e) => {
            if (e.target === this.newsModal) {
                this.closeNewsModal();
            }
        });

        // News form submission
        this.newsForm.addEventListener('submit', (e) => this.handleNewsSubmit(e));
    }

    renderNews() {
        const filteredNews = this.currentFilter === 'todos' 
            ? this.newsData 
            : this.newsData.filter(news => news.category === this.currentFilter);

        if (filteredNews.length === 0) {
            this.newsGrid.innerHTML = `
                <div class="no-news">
                    <i class="fas fa-newspaper"></i>
                    <p>No hay noticias en esta categoría</p>
                </div>
            `;
            return;
        }

        this.newsGrid.innerHTML = filteredNews.map(news => `
            <div class="news-item" data-id="${news.id}">
                <div class="news-header">
                    <span class="news-category category-${news.category}">
                        ${utils.getCategoryLabel(news.category)}
                    </span>
                    <h3 class="news-title">${news.title}</h3>
                    <div class="news-date">
                        <i class="fas fa-calendar"></i>
                        ${utils.formatDate(news.date)}
                    </div>
                </div>
                <div class="news-content">
                    <p>${news.content}</p>
                    <div class="news-actions">
                        <button class="news-action-btn like-btn" data-id="${news.id}">
                            <i class="fas fa-heart"></i>
                            <span class="like-count">${news.likes}</span>
                        </button>
                        <button class="news-action-btn comment-btn" data-id="${news.id}">
                            <i class="fas fa-comment"></i>
                            <span>${news.comments}</span>
                        </button>
                        <button class="news-action-btn share-btn" data-id="${news.id}">
                            <i class="fas fa-share"></i>
                        </button>
                        <button class="news-action-btn delete-btn" data-id="${news.id}">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        `).join('');

        this.setupNewsActionListeners();
    }

    setupNewsActionListeners() {
        // Like buttons
        document.querySelectorAll('.like-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const newsId = parseInt(e.currentTarget.dataset.id);
                const news = this.newsData.find(n => n.id === newsId);
                if (news) {
                    news.likes++;
                    this.renderNews();
                }
            });
        });

        // Comment buttons
        document.querySelectorAll('.comment-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                this.showNotification('Función de comentarios próximamente', 'info');
            });
        });

        // Share buttons
        document.querySelectorAll('.share-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const newsId = parseInt(e.currentTarget.dataset.id);
                const news = this.newsData.find(n => n.id === newsId);
                if (news) {
                    if (navigator.share) {
                        navigator.share({
                            title: news.title,
                            text: news.content,
                            url: window.location.href
                        });
                    } else {
                        utils.copyToClipboard(`${news.title}\n${news.content}`);
                        this.showNotification('Noticia copiada al portapapeles', 'success');
                    }
                }
            });
        });

        // Delete buttons
        document.querySelectorAll('.delete-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
                const newsId = parseInt(e.currentTarget.dataset.id);
                if (confirm('¿Estás seguro de que quieres eliminar esta noticia?')) {
                    this.newsData = this.newsData.filter(n => n.id !== newsId);
                    this.renderNews();
                    this.showNotification('Noticia eliminada correctamente', 'success');
                }
            });
        });
    }

    openNewsModal() {
        this.newsModal.style.display = 'block';
        document.body.style.overflow = 'hidden';
    }

    closeNewsModal() {
        this.newsModal.style.display = 'none';
        document.body.style.overflow = 'auto';
        this.newsForm.reset();
    }

    handleNewsSubmit(e) {
        e.preventDefault();
        
        const newNews = {
            id: this.newsIdCounter++,
            title: document.getElementById('newsTitle').value,
            category: document.getElementById('newsCategory').value,
            content: document.getElementById('newsContent').value,
            date: document.getElementById('newsDate').value,
            likes: 0,
            comments: 0
        };

        this.newsData.unshift(newNews);
        this.renderNews();
        this.closeNewsModal();
        this.showNotification('Noticia publicada correctamente', 'success');
    }

    showNotification(message, type = 'info') {
        const notification = document.createElement('div');
        notification.className = `notification notification-${type}`;
        notification.innerHTML = `
            <i class="fas fa-${utils.getNotificationIcon(type)}"></i>
            <span>${message}</span>
        `;
        
        // Add notification styles if not already added
        if (!document.querySelector('#notification-styles')) {
            const style = document.createElement('style');
            style.id = 'notification-styles';
            style.textContent = `
                .notification {
                    position: fixed;
                    top: 100px;
                    right: 20px;
                    background: white;
                    padding: 1rem 1.5rem;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    z-index: 3000;
                    transform: translateX(400px);
                    transition: transform 0.3s ease;
                    max-width: 350px;
                }
                .notification.show {
                    transform: translateX(0);
                }
                .notification-success {
                    border-left: 4px solid #10b981;
                    color: #059669;
                }
                .notification-info {
                    border-left: 4px solid #3b82f6;
                    color: #1d4ed8;
                }
                .notification-error {
                    border-left: 4px solid #ef4444;
                    color: #dc2626;
                }
            `;
            document.head.appendChild(style);
        }
        
        document.body.appendChild(notification);
        
        // Trigger animation
        setTimeout(() => notification.classList.add('show'), 100);
        
        // Remove notification after 3 seconds
        setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => {
                if (notification.parentNode) {
                    notification.parentNode.removeChild(notification);
                }
            }, 300);
        }, 3000);
    }
}
